import { useState } from 'react'
import { computeStreak, countCompletedSessions } from '../lib/exercise'

// Las push solo llegan a la app Android, que expone getFcmToken en su puente JS.
const supportsPush = typeof window !== 'undefined' && typeof window.Android?.getFcmToken === 'function'

function ReminderSettings({ weeklyConfig, onSave }) {
  const [enabled, setEnabled] = useState(Boolean(weeklyConfig?.notificationsEnabled))
  const [time, setTime] = useState(weeklyConfig?.reminderTime ?? '06:00')
  const [status, setStatus] = useState('')

  async function handleSave() {
    setStatus('Guardando...')
    try {
      await onSave({ notificationsEnabled: enabled, reminderTime: time })
      setStatus('Recordatorio guardado.')
    } catch {
      setStatus('No pudimos guardar el recordatorio.')
    }
  }

  return (
    <section className="profile-info">
      <div>
        <span>Recordatorio diario</span>
        <input type="checkbox" checked={enabled} onChange={(event) => setEnabled(event.target.checked)} />
      </div>
      <div>
        <span>Hora</span>
        <input type="time" step={300} value={time} onChange={(event) => setTime(event.target.value)} />
      </div>
      <button type="button" className="secondary full-width" onClick={handleSave}>
        Guardar recordatorio
      </button>
      {status && <p className="subtitle">{status}</p>}
    </section>
  )
}

function Profile({
  profile,
  plan,
  completion,
  subscription,
  onReset,
  isFirebaseConfigured,
  linkedEmail,
  onOpenMembership,
  weeklyConfig,
  onSaveReminders,
}) {
  const streak = computeStreak(plan, completion)
  const completedSessions = countCompletedSessions(plan, completion)
  const totalSessions = Object.keys(plan).length

  return (
    <main className="screen">
      <section className="dashboard-header">
        <p className="eyebrow">Tu perfil</p>
        <h1>{profile.fullName}</h1>
        <p className="subtitle">{profile.goal}</p>
      </section>

      <section className="streak-grid">
        <article className="streak-card">
          <p>Racha actual</p>
          <strong>{streak} {streak === 1 ? 'dia' : 'dias'}</strong>
        </article>
        <article className="streak-card">
          <p>Sesiones completadas</p>
          <strong>{completedSessions}/{totalSessions}</strong>
        </article>
      </section>

      <section className="profile-info">
        <div>
          <span>Nivel</span>
          <strong>{profile.level}</strong>
        </div>
        <div>
          <span>Dias por semana</span>
          <strong>{profile.daysPerWeek}</strong>
        </div>
        <div>
          <span>Edad</span>
          <strong>{profile.age}</strong>
        </div>
        <div>
          <span>Peso</span>
          <strong>{profile.weightKg} kg</strong>
        </div>
        <div>
          <span>Altura</span>
          <strong>{profile.heightCm} cm</strong>
        </div>
      </section>

      {isFirebaseConfigured && linkedEmail && (
        <section className="profile-info">
          <div>
            <span>Cuenta</span>
            <strong>{linkedEmail}</strong>
          </div>
        </section>
      )}

      {isFirebaseConfigured && supportsPush && onSaveReminders && (
        <ReminderSettings weeklyConfig={weeklyConfig} onSave={onSaveReminders} />
      )}

      {subscription?.active && (
        <section className="legal-links">
          <button type="button" className="legal-link-button" onClick={onOpenMembership}>
            Membresia · Activa
          </button>
        </section>
      )}

      <section className="legal-links">
        <a href="/politica-privacidad-v2.html" target="_blank" rel="noopener noreferrer">
          Política de privacidad
        </a>
        <a href="/terminos-condiciones.html" target="_blank" rel="noopener noreferrer">
          Términos y condiciones
        </a>
      </section>

      <button type="button" className="secondary full-width danger-text" onClick={onReset}>
        Reiniciar plan
      </button>
    </main>
  )
}

export default Profile
